import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import { renderCampaing, renderPost, renderSharedPost } from './utils'
import './MasoryPostCard.css'

const MasoryPostCard = ({
    linkPath,
    dataPost,
    index,
    style,
    options
}) => {

    const link = (dataPost.multimedia?.type.includes('video/hls') || dataPost?.postIdContent?.multimedia?.type.includes('video/hls'))  ? "/Stream/" : linkPath
    const [isHover, setIsHover] = useState(false);
    const history = useHistory()
    const handlerGoPost = () => {
        const idGo = ( dataPost.multimedia?.type.includes('video/hls') &&  dataPost?.postIdContent )? dataPost?.postIdContent?._id  : dataPost._id
        history.push({
            pathname: link +  idGo,
            state: {
                isMark: false,
                data: dataPost,
                dataShare: dataPost.typePost === 4 ? dataPost : false,
                isProfessional: false,
                isHome: true
            }
        })
    }

    return (
        <div
            onMouseLeave={() => setIsHover(false)}
            onMouseEnter={() => setIsHover(true)}

            onClick={() => {
                if (dataPost.type != "postCampaing") {
                    handlerGoPost()
                } else {

                }

            }} key={index} style={style} className="pointer post">
            {
                dataPost.type != "postCampaing" ? <>
                    {dataPost.typePost === 4 ?
                        renderSharedPost(dataPost.postIdContent, dataPost, isHover, options, style) :
                        renderPost(dataPost, isHover, options, style)
                    }
                </> : (
                     renderCampaing(dataPost,style,isHover)
                )
            }

        </div>
    )
}

export default MasoryPostCard
